export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["संख्या"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नाम"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रद्द करना"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["बचाना"])}
}